import React, { Fragment } from 'react';
import { useHistory } from 'react-router-dom';

// Auth removed - redirect to home
const Login = () => {
    const history = useHistory();

    // Redirect to home since auth is disabled
    React.useEffect(() => {
        history.push('/');
    }, [history]);

    return (
        <Fragment>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <p>Redirecting...</p>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Login;
